import { Component, OnInit } from '@angular/core';
import { TodolistService, TodolistEntry, calculateNumCompleted } from 'assets-service';
import { TodolistAddDialogComponent } from './dialogs/todolist-add-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { TodolistViewDialogComponent } from './dialogs/todolist-view-dialog.component';

@Component({
  selector: 'app-todolist',
  templateUrl: './todolist.component.html',
  styleUrls: ['./todolist.component.css']
})
export class TodolistComponent implements OnInit {

  todolistEntries: any;
  allowsDelete: boolean = false;

  constructor(public dialog: MatDialog, private todolistService: TodolistService) { }

  ngOnInit() {
    this.updateList();
  }

  tickEntry(entry: TodolistEntry) {
    this.todolistService.toggleComplete(entry.id).subscribe(
      response => this.updateList()
    );
  }

  updateList() {
    this.todolistService.getTodoList().subscribe(
      entries => this.todolistEntries = entries.items
    );
  }

  addEntry() {
    this.dialog.open(TodolistAddDialogComponent, {
      panelClass: 'dialog-resizable',
      width: '600px',
      data: { todolist: this }
    });
  }

  viewEntry(entry: TodolistEntry) {
    this.dialog.open(TodolistViewDialogComponent, {
      panelClass: 'dialog-resizable',
      width: '600px',
      data: { entry: entry }
    });
  }

  removeEntry(entry: TodolistEntry) {
    this.todolistService.removeEntry(entry.id).subscribe(
      response => this.updateList()
    );
  }

  calculateNumCompleted(entry: TodolistEntry) {
    return calculateNumCompleted(entry);
  }

}
